import { HttpService, getChannelId } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { getIntendType, isLoggedIn, getAPPID, isSequentialFlow } from '../../components/common/Helpers/index';
import { store } from '../../configureStore';
import { postdataVal } from '../../components/common/Helpers/helperaction';

// const loggedIn = getCookie('loggedIn');

const formApiUrl = (urlKey = '') => `${getSecureBaseUrl()}${apiUrls()[urlKey]}`;

export const getContactInfoFromApi = (data) => ({
  type: Constants.GET_CONTACT_INFO_FROM_API,
  data,
});
export const ispuContactInfoUpdateExpressCheckout = (data, homePhoneAdded) => ({
  type: 'ISPU_CONTACTINFO_UPDATE_EXPRESSCHECKOUT',
  data,
  homePhoneAdded,
});

export const editContactInfo = (data) => ({
  type: Constants.EDIT_LINK,
  data,
});

export const isContactInfoEdited = (data) => ({
  type: Constants.IS_CONTACT_INFO_EDITED,
  data,
});

export const updateContactInfoEditResponse = (data) => ({
  type: Constants.CONTACT_INFO_EDIT_RESPONSE,
  data,
});

export const updateContactInfoEditError = (data) => ({
  type: Constants.CONTACT_INFO_EDIT_ERROR,
  data,
});

export const updateInfoSuccessFlag = (data) => ({
  type: Constants.UPDATE_SUCCESS_FLAG,
  data,
});

export const updateISPUContactInfoFlag = (data) => ({
  type: Constants.UPDATE_ISPU_CONTACT_INFO_SUCCESS_FLAG,
  data,
});

export const postData = (data, homePhoneAdded, creditCheckRequest, installType) => ({
  type: Constants.POST_DATA,
  data,
  homePhoneAdded,
  creditCheckRequest,
  installType,
});

export const getContactInfoData = () => HttpService.get(formApiUrl('updateNSEContactInfoURL'));

export const postNSEContactInfoData = (contactInfoData) => ({
  type: 'POST_NSE_DATA',
  contactInfoData,
});

export const getContactInfoOnClick = (data, homePhoneAdded) => ({
  type: Constants.GET_CONT_INFO_ON_CLICK,
  data,
  homePhoneAdded,
});

export const postNonVzConsent = (data, homePhoneAdded) => ({
  type: Constants.POST_NON_VZ_CONSENT,
  data,
  homePhoneAdded,
});

// export const contactInfoISPUUpdate = (data) => ({
//   type: Constants.UPDATE_ISPU_CONTACT_INFO,
//   data,
// });

export const updateShippingAddress = (data) => ({
  type: Constants.UPDATE_SHIPPING_ADDRESS,
  data,
});

export const billingAddressErroReload = (data) => ({
  type: 'BILLING_ADDRESS1_ERROR_RELOAD',
  data,
});

const updateContactInfo = (postDataval) => HttpService.post(formApiUrl('updateContactInfoURL'), postDataval);

export const postNonVzConsentApiCall = (postDataval) => {
  HttpService.post(formApiUrl('addSMSConsentURL'), postDataval);
};

export const postNSEContactInfoDataAPI = (data, homePhoneAdded) => {
  const intendTypeval = getIntendType();
  let billingdetails = {};
  billingdetails = data && data.billingAddress ? data.billingAddress : {};

  const lines = [
    {
      //  mtn: 'newLine1',
      firstName: billingdetails.firstName || '',
      lastName: billingdetails.lastName || '',
      email: billingdetails.email || '',
      contactNumber: billingdetails.phoneNumber || '',
      address: {
        addressLine1: billingdetails.addressLine1 || '',
        addressLine2: billingdetails.addressLine2 || '',
        apartmentNo: '',
        city: billingdetails.city || '',
        state: billingdetails.state || '',
        zipCode: billingdetails.zipCode || '',
      },
    },
  ];
  if (homePhoneAdded) {
    lines.push(lines[0]);
  }
  const postDataval = {
    serviceHeader: {
      clientId: 'VZW-DOTCOM',
      statusMsg: '',
      correlationId: '',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          customerInfo: {
            cartCreator: data && data.cartDetails && data.cartDetails.cartCreator ? data.cartDetails.cartCreator : '',
            globalId: data && data.cartDetails && data.cartDetails.cartCreator ? data.cartDetails.cartCreator : '',
            customerType: 'N',
          },
          cartInfo: {
            itemType: 'USERCONTACTINFO',

            intendType: intendTypeval,
            action: 'UPDATE',
            accountPin: data && data.accountPin,
            lines,
            paperLessBilling: true,
            receiveSpecialOfferUpdates: data && data.receiveSpecialOfferUpdates,
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: intendTypeval,
            processStep: 'ContactInfo',
            processAction: 'updateContactInfo',
          },
        },
      },
    },
  };
  const { isNonVzConsentCheckboxChecked } = store.getState().contactInfo;
  const addSMSConsentParam = {
    mtn: billingdetails?.phoneNumber,
    lineOfBusiness: 'Wireless',
    vzPurpose: 'Transactional',
    status: 'Active',
    consentType: 'single',
    pageName: 'Contact Info',
    chkBox: 'Checked',
    spid: store.getState().contactInfo?.phoneAPiResponse?.data?.spid,
  };
  if (data.isCradleSuccess && !data.isEmailExists && !data.isUniversalProfileCreated) {
    postDataval.serviceBody.serviceRequest.context.amCreateProfilerequest = {
      // email: data?.billingAddress?.email,
      email: store.getState().contactInfo?.encEmail || '',
      profileName: '', // can be empty for nse flow
      password: data?.password,
      isEncrypted: 'Y',
    };
  }
  if (isNonVzConsentCheckboxChecked) {
    postNonVzConsentApiCall(addSMSConsentParam);
  }
  return updateContactInfo(postDataval);
};

export const postContactInfoData = (data, homePhoneAdded) => {
  let processingMTN = 'newLine1';
  if (homePhoneAdded) {
    processingMTN = '';
  }
  // const postDataval = { data };
  // debugger;
  const intendTypeval = getIntendType();
  const postDataval = {
    serviceHeader: {
      clientId: 'VZW-DOTCOM',
      statusMsg: '',
      correlationId: '',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          customerInfo: {
            ...(isSequentialFlow()
              ? {}
              : { accountNumber: data && data.cartDetails && data.cartDetails.accountNumber ? data.cartDetails.accountNumber : '' }),

            cartCreator: data && data.cartDetails && data.cartDetails.cartCreator ? data.cartDetails.cartCreator : '',
            globalId: '',
            ...(isSequentialFlow() ? {} : { processingMTN }),

            ...(isSequentialFlow() ? { customerType: 'N' } : {}),
          },
          cartInfo: {
            itemType: isSequentialFlow() ? 'USERCONTACTINFO' : 'USERINFO',

            intendType: intendTypeval,
            action: 'UPDATE',
            lines: data && data.param,
            receiveSpecialOfferUpdates: isSequentialFlow() ? data?.param[0]?.receiveSpecialOfferUpdates : data.param.receiveSpecialOfferUpdates,
            ...(isSequentialFlow() ? { paperLessBilling: true } : {}),
            ...(isSequentialFlow() ? { accountPin: data?.cartDetails?.accountPin ? data?.cartDetails?.accountPin : '' } : {}),
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: intendTypeval,
            processStep: 'ContactInfo',
            processAction: 'updateContactInfo',
          },
        },
      },
    },
  };
  // debugger;
  return updateContactInfo(postDataval);
};

const enableEmailandTextNotification = (data, loggedIn) =>
  loggedIn === false ? 'Y' : data && data.param && data.param[0] && data.param[0].receiveSpecialOfferUpdates ? 'Y' : 'N';

const genericPostCall = (apiUrl, postDataValue, sucessCallBack = () => {}, errorCallBack = () => {}) =>
  HttpService.post(apiUrl, postDataValue)
    .then((response) => sucessCallBack(response))
    .catch((error) => errorCallBack(error));

const getIspuContactInfoObj = (data, loggedIn) => ({
  customerFirstName: loggedIn === true ? data && data.param && data.param[0] && data.param[0].firstName : data?.billingAddress?.firstName,
  customerLastName: loggedIn === true ? data && data.param && data.param[0] && data.param[0].lastName : data?.billingAddress?.lastName,
  customerEmailId: loggedIn === true ? data && data.param && data.param[0] && data.param[0].email : data?.billingAddress?.email,
  customerMobile: loggedIn === true ? data && data.param && data.param[0] && data.param[0].phoneNumber : data?.billingAddress?.phoneNumber,
  enableEmailandTextNotification: enableEmailandTextNotification(data, loggedIn),
});
const getAddressObj = (data, loggedIn) => ({
  firstName: loggedIn === true ? data && data.param && data.param[0] && data.param[0].firstName : data?.billingAddress?.firstName,
  lastName: loggedIn === true ? data && data.param && data.param[0] && data.param[0].lastName : data?.billingAddress?.lastName,
  addressLine1: '',
  addressLine2: '',
  city: '',
  zipCode: '',
  state: '',
  emailId: loggedIn === true ? data && data.param && data.param[0] && data.param[0].email : data?.billingAddress?.email,
  phoneNumber: loggedIn === true ? data && data.param && data.param[0] && data.param[0].phoneNumber : data?.billingAddress?.phoneNumber,
});
export const updateISPUContactInfo = (data, homePhoneAdded) => {
  // debugger;
  const loggedIn = getAPPID() === 'AAL' || isSequentialFlow();
  let processingMTN = 'newLine1';
  const lines = [
    {
      multiLineSeqNumber: 1,
      ispuContactInfo: getIspuContactInfoObj(data, loggedIn),
      address: getAddressObj(data, loggedIn),
    },
  ];

  if (homePhoneAdded) {
    processingMTN = '';
    lines.push({
      multiLineSeqNumber: 2,
      ispuContactInfo: getIspuContactInfoObj(data, loggedIn),
      address: getAddressObj(data, loggedIn),
    });
  }
  const postDataISPU = postdataVal(processingMTN, lines);
  return new Promise((resolve) => {
    const apiURL = formApiUrl('updateISPUContactInfo');
    return genericPostCall(apiURL, postDataISPU, resolve);
  });
};
export const updateISPUContactInfoForExpressCheckout = (data, homePhoneAdded, isExpressCheckout) => {
  // debugger;
  const loggedIn = getAPPID() === 'AAL' || isSequentialFlow();
  let processingMTN = 'newLine1';
  const lines = [
    {
      multiLineSeqNumber: 1,
      ispuContactInfo: getIspuContactInfoObj(data, loggedIn),
      address: getAddressObj(data, loggedIn),
    },
  ];

  if (homePhoneAdded) {
    processingMTN = '';
    lines.push({
      multiLineSeqNumber: 2,
      ispuContactInfo: getIspuContactInfoObj(data, loggedIn),
      address: getAddressObj(data, loggedIn),
    });
  }
  const postDataISPU = postdataVal(processingMTN, lines, isExpressCheckout);
  return new Promise((resolve) => {
    const apiURL = formApiUrl('updateISPUContactInfo');
    return genericPostCall(apiURL, postDataISPU, resolve);
  });
};

export const updateAddress = (data) => {
  const postData4updateAddress = {
    serviceHeader: {
      clientId: '',
      statusMsg: '',
      correlationId: '',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          skipCheckoutCall: true,
          isFwaServiceAddress: data?.isFwaServiceAddress,
          customerInfo: {
            accountNumber: '',
            cartCreator: '',
            processingMTN: 'newLine1',
          },
          cartInfo: {
            action: 'UPDATE',
            itemType: 'SHIPPINGADDRESS',
            userAction: 'updateShippingAddress',
            updateShippingContactInfo: false,
            intendType: `${getIntendType()}`,
            shipmentAddress: {
              lines: [
                {
                  multiLineSeqNumber: 1,
                  address: {
                    firstName: '',
                    lastName: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    zipCode: '',
                    state: '',
                    emailId: data && data.param && data.param.email ? data.param.email : '',
                    phoneNumber: data && data.param && data.param.contactNumber ? data.param.contactNumber : '',
                  },
                },
              ],
            },
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: `${getIntendType()}`,
            processStep: 'ShippingOptions',
            processAction: 'updateShippingAddress',
          },
        },
      },
    },
  };
  return new Promise((resolve) => {
    const apiURL = formApiUrl('updateShippingAddress');
    return genericPostCall(apiURL, postData4updateAddress, resolve, (error) => {
      console.log(error);
    });
  });
};

export const showCart = (data) => ({
  type: 'SHOWCART',
  data,
});

export const getZipCodeDetails = (zipCode) => ({
  type: 'GET_ZIPCODE_DETAILS',
  zipCode,
});

export const getZipCodeDetailsAPI = ({ zipCode }) => {
  const postJSON = {
    data: {
      zipCode,
    },
  };
  return HttpService.post(formApiUrl('zipMarketDetailsUrl'), postJSON);
};

export const sendBillingFormValues = (data) => ({
  type: 'BILLING_FORM_VALUES',
  data,
});
export const sendContactFormValues = (data) => ({
  type: 'CONTACT_FORM_VALUES',
  data,
});

export const sendPinFormValues = (data) => ({
  type: 'SECURE_PIN_FORM_VALUES',
  data,
});

export const billingCTA = (data) => ({
  type: 'BILLING_CTA_VALUES',
  data,
});
export const contactContinueCTA = (data) => ({
  type: 'CONTACT_CONTINUE_CTA_VALUES',
  data,
});

export const billingAddress1CTA = (data) => ({
  type: 'BILLING_ADDRESS1_CTA_VALUES',
  data,
});
export const billingAddress2CTA = (data) => ({
  type: 'BILLING_ADDRESS2_CTA_VALUES',
  data,
});
export const billingZipcodeCTA = (data) => ({
  type: 'BILLING_ZIPCODE_CTA_VALUES',
  data,
});
export const contactFnameCTA = (data) => ({
  type: 'CONTACT_FNAME_CTA_VALUES',
  data,
});
export const contactLnameCTA = (data) => ({
  type: 'CONTACT_LNAME_CTA_VALUES',
  data,
});
export const contactEmailCTA = (data) => ({
  type: 'CONTACT_EMAIL_CTA_VALUES',
  data,
});
export const contactPhoneCTA = (data) => ({
  type: 'CONTACT_PHONE_CTA_VALUES',
  data,
});
export const securePinCTA = (data) => ({
  type: 'SECURE_PIN_CTA_VALUES',
  data,
});
export const secureConfirmPinCTA = (data) => ({
  type: 'SECURE_CONFIRM_PIN_CTA_VALUES',
  data,
});

export const billingInfoUpdate = (data) => ({
  type: 'BILLING_OPTION_CHANGE',
  data,
});

export const splOfferFlag = (data) => ({
  type: 'SPL_OFFER_FLAG',
  data,
});

export const billingAddress2unitItems = (data) => ({
  type: 'BILLING_ADDRESS2_UNIT_ITEMS',
  data,
});

export const billingAddress2unitArray = (data) => ({
  type: 'BILLING_ADDRESS2_UNIT_ARRAY',
  data,
});

export const emailVaildationAPI = (email, id, isUniversalProfileCreated) => ({
  type: Constants.EMAIL_VALIDATION_FROM_API,
  data: { email, id, isUniversalProfileCreated },
});

export const phoneVaildationAPI = (phoneNumber, id, isUniversalProfileCreated) => ({
  type: Constants.PHONE_VALIDATION_FROM_API,
  data: { phoneNumber, id, isUniversalProfileCreated },
});

export const setEmailValidationdata = (data) => ({
  type: 'EMAIL_VALIDATION',
  response: data,
});

export const emailValidationAPI = ({ email, id, isCradleFlow }) => {
  // const postData = {
  //   serviceHeader: {
  //     clientId: 'VZW-ECOM',
  //     statusMsg: 'PEGA generated message',
  //     correlationId: '',
  //     sessionId: '',
  //     serviceName: 'SalesOrderPurchase',
  //     userId: '',
  //     statusCode: '0',
  //   },
  //   serviceBody: {
  //     serviceRequest: {
  //       context: {
  //         caseId: '',
  //         customerInfo: {
  //           accountNumber: '',
  //           cartCreator: '',
  //           processingMTN: '',
  //         },
  //         cartInfo: {
  //           action: 'UPDATE',
  //           itemType: 'ContactInfo',
  //           intendType: `${getIntendType()}`,
  //           userAction: 'updateContactInfo',
  //           emailId: email,
  //         },
  //         contextInfo: {
  //           callReason: 'SalesOrderPurchase',
  //           intent: `${getIntendType()}`,
  //           processStep: 'ContactInfo',
  //           processAction: 'updateContactInfo',
  //         },
  //       },
  //     },
  //   },
  // };
  let postData1 = {};
  postData1 = {
    meta: {
      client: getChannelId(),
      user: '',
      clientCorrrelationId: '',
      timestamp: '',
    },
    data: {
      emailId: email,
      userAction: 'updateContactInfo',
    },
  };

  let apiURL = formApiUrl('validateEmail');

  if (id === 'contactInfoVdsEmail' || id === 'shippingInfoVdsEmail' || id === 'appointmentVdsEmail') {
    apiURL = formApiUrl('validateEmailVds');
    postData1 = {
      meta: {
        client: getChannelId(),
        user: '',
        clientCorrrelationId: '',
        timestamp: '',
      },
      data: {
        emailId: email,
        userAction: 'updateContactInfo',
        customerType: 'Wireless',
        version: 'v2',
      },
    };
    if (isCradleFlow) {
      postData1.data.amRegistrationRequired = true;
    }
  }

  return new Promise((resolve) => genericPostCall(apiURL, postData1, resolve));
  // Mock Response, remove this once actual API called
  // let isValid = '';
  // if (email === 'test@gmail.com' || email === 'test@gmail.co' || email === 'test@gmail.c') {
  //   isValid = 'false';
  // } else {
  //   isValid = 'true';
  // }
  // return {
  //   data: { valid: isValid, emailId: email },
  // };
};

// phoneValidationAPI to check VZ or VZ number
export const phoneValidationAPI = ({ phoneNumber }) => {
  let postData1 = {};
  postData1 = {
    data: {
      mtn: phoneNumber,
      purposeName: 'Transactional',
      lineOfBusiness: 'Wireless',
      flowName: 'FWA Contact Info Order',
    },
  };

  const apiURL = formApiUrl('validatePhone');

  return new Promise((resolve) => genericPostCall(apiURL, postData1, resolve));
};

export const accMainEmailVerify = (data) => ({
  type: Constants.ACCOUNT_MAINTENENCE_EMAIL_VERIFICATION,
  data,
});

export const accMainEmailValidation = (dataObj) =>
  new Promise((resolve) => {
    const postEmailValidateData = {
      data: {
        action: 'manual',
        email: dataObj?.data.email,
        prospectCustomer: !isLoggedIn(),
      },
    };
    const apiURL = formApiUrl('accMainEmailVerifyUrl');
    return genericPostCall(apiURL, postEmailValidateData, resolve);
  });

export const postPushMessageAPI = (data) => {
  const pushContactInfo = data.billingAddress;
  const postJSON = {
    emailAddress: pushContactInfo.email,
    mobileNumber: pushContactInfo.phoneNumber,
    firstName: pushContactInfo.firstName,
    lastName: pushContactInfo.lastName,
    type: 'coverageLead',
    address: {
      address1: pushContactInfo.addressLine1,
      address2: pushContactInfo.addressLine2,
      city: pushContactInfo.city,
      state: pushContactInfo.state,
      zipcode: pushContactInfo.zipCode,
    },
  };
  return HttpService.post(formApiUrl('pushMessage'), postJSON);
};

export const buildShippingOptionsContactInput = (selectedShipping, selectedslots, sddOption, homePhoneAdded) => ({
  type: Constants.CONTACT_POST_SHIPPING_OPTION,
  selectedShipping,
  selectedslots,
  sddOption,
  homePhoneAdded,
});

export const buildShippingOptionsInputFromContactinfo = (selectedShipping, selectedslots, sddOption, homePhoneAdded) => ({
  type: 'POST_SHIPPING_OPTION_FROM_CONTACT',
  selectedShipping,
  selectedslots,
  sddOption,
  homePhoneAdded,
});

export const contactFetchSMSEnabledDevices = (data) => ({
  type: Constants.CONTACT_GET_ENABLED_DEVICES,
  data,
});

export const aemAPICall = () => ({
  type: 'AEM_API_CALL',
});

export const callAEMAPIURL = () => {
  const apiURL = formApiUrl('aemUrl');
  return new Promise((resolve) => genericPostCall(apiURL, {}, resolve));
};

export const universalProfileBannerDisplayed = () => ({ type: Constants.UNIVERSAL_PROFILE_BANNER_DISPLAYED });

export const storePassword = (data) => ({ type: Constants.SHELL_CODE, data });

export const isPasswordValidationfailed = (data) => ({ type: Constants.SHELL_VALIDATION_FAILED, data });

export const toggleTermsandConditionsBanner = (data) => ({ type: Constants.SHOW_TERMS_AND_CONDITIONS_BANNER, payload: data });

export const toggleEmailExistBanner = (data) => ({ type: Constants.SHOW_EMAIL_EXIST_BANNER, payload: data });

export const callCradleApi = () => ({ type: Constants.CALL_CRADLE_API });

export const postCradleApi = () => {
  const apiURL = formApiUrl('cradleApi');
  const postData1 = {
    properties: [{ name: 'pageName', value: 'contactInfo' }],
  };

  return new Promise((resolve) => genericPostCall(apiURL, postData1, resolve));
};

export const hardToGuessPasswordApi = (data) => {
  const apiURL = formApiUrl('hardToGuessPwdValidationUrl');
  return HttpService.post(apiURL, data);
};
